import React from 'react';
import AllCourses from '../components/AllCourses/index';
function AllCoursesPage() {
    return <AllCourses />;
}

export default AllCoursesPage;
